import(/* webpackMode: "eager" */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/loading.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/pages/Homepage.jsx");
